import React from 'react'

import './styles.scss'

export const transformName = {
  in: (audience) => ({
    ...audience,
    name: audience.name
      .split('>')
      .map((v) => v.trim())
      .filter(Boolean),
  }),
  out: (audience) => ({
    ...audience,
    name: audience.name.filter(Boolean).join(' > '),
  }),
}

const NameInput = ({ label, value, onChange, addInput }) => {
  return (
    <div className="split-name">
      <label>{label}</label>
      <div className="split-name__inputs">
        {value.map((v, index) => (
          <div key={index}>
            <input
              type="text"
              value={v}
              onChange={onChange(index)}
              placeholder="leave empty to remove"
            />
            <div className="split-name__divider">
              &gt;
              <button title="Add input" onClick={addInput(index + 1)}>
                +
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default NameInput
